import api from "@/services/api";

class UpdateFranchiseAssociateStatus {
  execute = async (id: string, status: "ACTIVE" | "INACTIVE") => {
    const response = await api().patch(`/franchise-associates/${id}/status`, {
      status,
    });
    return response.data;
  };
}

export { UpdateFranchiseAssociateStatus };
